var PassengerCategory = /** @class */ (function () {
    function PassengerCategory(props) {
        this.typePrice = TypePrice.byPassenger;
        Object.assign(this, props);
    }
    return PassengerCategory;
}());
export default PassengerCategory;
export var TypePassenger = {
    Adult: 'adult',
    Pensioner: 'pensioner',
    Senior: 'senior',
    Child: 'child',
    Infant: 'infant',
    Student: 'student',
    Handicapped: 'handicapped',
    Military: 'military',
    Resident: 'resident', // residente
};
export var TypePrice = {
    byPassenger: 'byPassenger',
    byGroup: 'byGroup', // precio fijo independientemente de los pasajeros que vayan
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/PassengerCategories/Model.ts
// module id = 203
// module chunks = 0